/**
 * 工具函数
 * created by xxh
 * 2018年08月31日
 */
let Base64 = require('js-base64').Base64

 /**
  * 查找url参数中指定name的参数
  * @param {*} name
  */
export function getQuery (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

 /**
  * 查找url参数中指定name的参数 多个问号
  * @param {*} name
  */
export function getQueryNew (name) {
  var reg = new RegExp(name + '=([^&]*)')
  //
  // var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let index = window.location.href.indexOf('?')
  var r = decodeURIComponent(window.location.href).substr(index, window.location.href.length).match(reg)
  // alert(decodeURIComponent(window.location.href).substr(index, window.location.href.length))
  // alert(r)
  if (r != null) {
    // return unescape(r[2])
    return unescape(r[1])
  }
  return null
}

/**
 * 优惠券解密
 * @param 加密参数
 */
export function xDeCode(param) {
  if (param) {
    // 进行解密
    let Separator = 'lifaair'
    let str = Base64.decode(param)
    let finStr = str.replace(new RegExp(Separator, 'g'), ",")
    // 去除最后一位 ,
    finStr = finStr.substr(0, finStr.length - 1)
    return finStr
  }
  return null
}




// WEBPACK FOOTER //
// ./src/utils/index.js